import React, { Component } from "react";
import GoogleMapReact from "google-map-react";
import RoomIcon from "@material-ui/icons/Room";
import { connect } from "react-redux";
import Loading from "../Loading";
import { findHighlightColor } from "./ContactPageTools";
import LocalMallIcon from "@material-ui/icons/LocalMall";

const Marker = ({ val }) => (
  <div>
    <span
      className="pin bounce"
      style={{ background: findHighlightColor(val) }}
    ></span>
    <span className="pulse"></span>
  </div>
);

class SimpleMap extends Component {
  countries = {
    Kuwait: { lat: 29.246304, lng: 48.002865, defaultZoom: 9.5 },
    Qatar: { lat: 25.3548, lng: 51.183, defaultZoom: 7.5 },
  };
  render() {
    const { customTexts } = this.props;
    const branches = this.props.branches.filter((b) => !b.hide_branch);
    if (!branches.length)
      return (
        <div
          className="w-100 text-center border-top  py-3 mb-1"
          style={{
            height: 60,
            backgroundColor: "white",
            borderWidth: 1,
            borderTopStyle: "solid",
            borderBottomStyle: "solid",
            borderBottomColor: "#d4d9d9",
            borderTopColor: "#d4d9d9",
            textAlign: "center",
            marginTop: 60,
          }}
        >
          <p style={{ lineHeight: 2 }}>
            {this.props.language == "english"
              ? customTexts.no_provided_location
              : customTexts.no_provided_location_ar}
          </p>
        </div>
      );

    const marks = this.props.markers.map((mar) => {
      return (
        <Marker
          lat={branches[mar].lat}
          lng={branches[mar].lng}
          val={mar}
          key={"Marker" + mar}
        />
      );
    });

    const default_center =
      this.countries[this.props.store.base_country] || this.countries["Kuwait"];

    const defaultBranch = branches.find((b) => !!b.lat);

    return (
      // Important! Always set the container height explicitly
      <div style={{ height: 300, width: "100%", marginTop: 55 }}>
        <GoogleMapReact
          bootstrapURLKeys={{
            key: process.env.REACT_APP_API_GOOGLE_MAPS,
          }}
          defaultCenter={{
            lat: defaultBranch
              ? parseFloat(defaultBranch.lat)
              : default_center.lat,
            lng: defaultBranch
              ? parseFloat(defaultBranch.lng)
              : default_center.lng,
          }}
          defaultZoom={default_center.defaultZoom || 10}
        >
          {marks}
        </GoogleMapReact>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    store: state.store.store,
    customTexts: state.store.store.settings.custom_texts,
  };
};

export default connect(mapStateToProps)(SimpleMap);
